import React from 'react'

import his_img1 from '../img/2013.jpg'
import his_img2 from '../img/2014_1.jpg'
import his_img3 from '../img/2014_2.jpg'
import his_img4 from '../img/2016_1.jpg'
import his_img5 from '../img/2023.jpg'
import his_img6 from '../img/hala.jpg'
import his_img7 from '../img/2022.jpg'

function Historia() {
  return (
    <div className='historia-container'>
      <h1>Historia</h1>
      <p>

      <img src={his_img1} alt='oldboje2013'></img>
Drużyna oldbojów w historii klubu występowała okazjonalnie z okazji
jubileuszów i meczów noworocznych. Po raz pierwszy oficjalnie została
zgłoszona do rozgrywek organizowanych przez Małopolski Związek Piłki
Nożnej w 2013 roku. Rok później w 2014 roku Grębałowianka wywalczyła
awans do I Krakowskiej Ligi Oldbojów na boisku z drugiego miejsca plasując
się tuż za Orłem Piaski Wielkie.
<img src={his_img6} alt='oldboje2013'></img>
 W tym samym roku rozegrała z okazji
Jubileuszu 60 – lecia Klubu mecz z Hutnikiem Kraków lat 90-
tych. W 2015 roku w rozgrywkach halowych uzyskała awans
do I Krakowskiej Ligi Halowej.

 W 2016 roku została
wicemistrzem I Krakowskiej Ligi Oldbojów na boisku wyprzedzając drużyny
oldboi Cracovii i Wisły Kraków.
<img src={his_img4} alt='oldboje2013'></img>
 W latach 2013-2017 Grębałowiankę oldboje
reprezentowali: Piotr Kokosza, Leszek Janiczak, Konrad Poplatek, Marcin
Wierzbiński, Piotr Zięba, Łukasz Zawada, Dawid Bohun, Jarosław
Krzyk, Jerzy Ostrowski, Bernard Łach, Grzegorz Luty, Piotr
Grzywa, Tomasz Madejczyk, Waldemar Zbroja, Marcin Stolarski, Łukasz
Korcala, Robert Kręcisz, Stanisław Sprynca, Artur Talaga, Mariusz
Wójcik, Daniel Gacek, Wojciech Sendor, Łukasz
Wierzbiński, Adam Gaudyn, Radosław Orlewicz, Jacek Mrozowski,
Jarosław Luty, Tomasz Towarek, Robert Bączek, Grzegorz Kapcia,
Paweł Kosmacz, Mariusz Kordylewski, Grzegorz Kuliś, Paweł Kulpiński.
Sztab drużyny: Bernard Łach – trener, Piotr Kokosza - kapitan,
Wojciech Sendor – kierownik, Sebastian Gregorczyk – kierownik,
Łukasz Zawada – współsponsor, Andrzej Dziedzic – prezes, Zdzisław
Wagner – prezes, Ryszard Chmiel – prezes, Grzegorz Sendor – wiceprezes,
Piotr Zdziarski – wiceprezes.
<img src={his_img2} alt='oldboje2013'></img>
Najważniejszym sukcesem drużyny oldbojów jest możliwość kontynuacji
pasji sportowej w dalszej przygodzie piłkarskiej z dobrymi kolegami i
przyjaciółmi. Za każdy dar spotkania jesteśmy wdzięczni. Razem dla KSG.
Ale skoro są punkty, tabele, gole i wyniki to nasza rywalizacja obok dobrej
zabawy trwa dalej. Możemy mówić też o kolejnych sukcesach: w 2020 roku
III miejsce w Pucharze Ligi Krakowa na boisku, w 2021 roku III miejsce
w Pucharze Ligi Krakowa na boisku, w 2022 roku Wicemistrzostwo
I Krakowskiej Ligi Olbojów (pod balonem) <br></br>
<br></br>
<img src={his_img3} alt='oldboje2013'></img>
Od 2015 roku drużyna K.S. Grębałowianka oldboje organizuje coroczny
mecz charytatywny dla osób niepełnosprawnych goszcząc ich na trybunach,
poczęstunkiem i wsparciem finansowym. Dla osób z niepełnosprawnością
intelektualną graliśmy : 2015 - Reprezentacja Sędziów MZPN, 2016 -
Jagiellonki - Ekstraklasa, 2017 - Hutnik Kraków - Mistrz Polski Juniorów z
1993, 2018 - Gwiazdy Hutnika, 2019 - Reprezentacja Polski
Dziennikarzy, 2020 - Grębałowianka Awans 2010, 2021 -
Reprezentacja Księży Archidiecezji Krakowskiej, 2022 - Rodzina i Przyjaciele,
2023 - Turniej trzech drużyn - Grębałowianka oldboje, Reprezentacja Księży
Archidiecezji Krakowskiej i Rodzina i Przyjaciele. Dziękujemy z serca.
Zanim powstała oficjalnie nasza drużyna oldbojów, okazyjnie grała mecze z
okazji jubileuszów ( w 1984 roku na 30-lecie klubu - trener Władysław Łach
oraz w 2004 roku z okazji Jubileuszu 50 - lecia klubu - trenerzy Bogdan Śloński,
Edward Bielewicz i Andrzej Sykta, Jubileuszu drużyny juniorów
Leszka Janiczaka, meczów towarzyskich z Anglikami, które organizował
Zdzisław Wagner.

Od 2002 roku nasz klub 1 stycznia rozgrywa mecz noworoczny dopisując
się do kilkudziesięcioletniej tradycji Cracovii. Głównie młodsi i starsi oldboje
oraz wychowankowie klubu wzmocnieni chętnymi aktualnie seniorami
rozpoczynają na sportowo Nowy Rok Piłkarski.<br></br>

<br></br>
Naszą drużynę w latach 2018 - 2024 reprezentowali: Piotr Kokosza,
Robert Strojek, Marcin Wierzbiński, Grzegorz Strojek, Andrzej
Mucharski, Konrad Poplatek, Łukasz Korcala, Piotr Jańczyk, Sebastian
Towarek, Piotr Zięba, Marcin Oleś, Grzegorz Rutka, Tomasz
Madejczyk, Piotr Krawczyk, Robert Dominik, Piotr
Franaszek, Paweł Gawęcki, Marcin Stolarski, Łukasz Lampart,
Dominik Nowak, Maciej Wejnar, Piotr Grzywa, Marcin Cecuga,
Łukasz Zawada, Jarosław Krzyk, Bernard Łach, Artur Talaga,
Mariusz Wójcik, Łukasz Wierzbiński, Marcin Pituła, Jan
Kalisz, Krzysztof Tynor, Grzegorz Rzepka, Jerzy
Ostrowski Grzegorz Luty, Adam Rajca, Tomasz Karaś, Marcin Biały,
Krzysztof Natkaniec, Dawid Bohun, Damian Kwiecień, Stanisław Sprynca,
Michał Telka, Paweł Ochlust. Sztab drużyny: Bernard Łach – trener,
Piotr Kokosza - kapitan, Grzegorz Strojek - kierownik, Robert Strojek –
kierownik, Jerzy Ostrowski – II trener, Łukasz Zawada – współsponsor
strojów, Piotr Zdziarski – prezes, Ryszard Chmiel – prezes, Tomasz Chmiel –
wiceprezes, Mateusz Tabor – wiceprezes, Zbigniew Belski – wiceprezes,
Stanisław Pituch – członek zarządu.</p>
<img src={his_img5} alt='oldboje2013'></img>
<img src={his_img7} alt='oldboje2013'></img>
      </div>
  )
}

export default Historia